import { render, staticRenderFns } from "./Partage.vue?vue&type=template&id=23bc7194&scoped=true&"
import script from "./Partage.vue?vue&type=script&lang=js&"
export * from "./Partage.vue?vue&type=script&lang=js&"
import style0 from "./Partage.vue?vue&type=style&index=0&id=23bc7194&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bc7194",
  null
  
)

export default component.exports